import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';

const ItemName = () => {
  const {
    BidStore: { auctionProduct },
  } = useStores();

  return (
    <div data-testid="item-name">
      {auctionProduct ? auctionProduct.product : '-'}
    </div>
  );
};

export default observer(ItemName);
